import "~/misc/common";
import { Controller } from "@hotwired/stimulus";
import { myGetNumValue } from "~/misc/common";

export default class extends Controller {
  connect() {
    console.log('initTransactionsForm');

    //var rate, amount, amount_huf;
    //
    //function getValues() {
    //  rate = $('#calc_rate').myGetNumValue();
    //  amount = myGetNumValue($('#transaction_amount').autoNumeric('get'));
    //  amount_huf = myGetNumValue($('#transaction_amount_huf').autoNumeric('get'));
    //}
    //
    //getValues();
    //if (amount && amount_huf) {
    //  $('#calc_rate').val(amount_huf / amount);
    //}
    //
    //$('#calc_rate').change(function () {
    //  getValues();
    //  if (rate) {
    //    if (amount) {
    //      $('#transaction_amount_huf').autoNumeric('set', amount * rate);
    //      $('#transaction_amount_huf_val').val(amount * rate);
    //    }
    //  } else {
    //    if (amount && amount_huf) {
    //      $('#calc_rate').val(amount_huf / amount);
    //    }
    //  }
    //});
    //
    //$('#transaction_amount').change(function () {
    //  getValues();
    //  if (rate) {
    //    if (amount) {
    //      $('#transaction_amount_huf').autoNumeric('set', amount * rate);
    //      $('#transaction_amount_huf_val').val(amount * rate);
    //    }
    //  } else {
    //    if (amount && amount_huf) {
    //      $('#calc_rate').val(amount_huf / amount);
    //    }
    //  }
    //});
    //
    //$('#transaction_amount_huf').change(function () {
    //  getValues();
    //  if (amount_huf && amount) {
    //    $('#calc_rate').val(amount_huf / amount);
    //  } else if (amount_huf && rate) {
    //    $('#transaction_amount').autoNumeric('set', amount_huf / rate);
    //    $('#transaction_amount_val').val(amount_huf / rate);
    //  } else if (amount && rate) {
    //    $('#transaction_amount_huf').autoNumeric('set', amount * rate);
    //    $('#transaction_amount_huf_val').val(amount * rate);
    //  } else if (amount && amount_huf) {
    //    $('#calc_rate').val(amount_huf / amount);
    //  }
    //
    //});
  }
}